import styled from 'styled-components';
import Box from 'relements/build/esm/ui/box';

const TopBarStyle = ({ theme, isExpanded }) => ({
  justifyContent: 'flex-end',
  padding: theme.space.zero,
  borderTopLeftRadius: isExpanded && '8px',
  backgroundColor: theme.colors.grey.neon,
});

export const TopBar = styled(Box)(TopBarStyle);

export const Iframe = styled.iframe`
  height: 100%;
  border-width: 0;
`;

const ContainerStyle = ({
  theme,
  isExpanded,
  isAnimating,
  top,
  width,
  transitionDuration,
}) => ({
  position: isAnimating || isExpanded ? 'absolute' : 'static',
  flexDirection: 'column',
  margin: theme.space.zero,
  padding: theme.space.zero,
  right: 0,
  zIndex: 3,
  top: isExpanded ? '3px' : top,
  height: '100vh',
  width: isExpanded ? '90vw' : width || '100%',
  boxShadow: isAnimating || (isExpanded && '0px 4px 26px rgba(0, 0, 0, 0.25)'),
  borderTopLeftRadius: isExpanded && '8px',
  transition: isExpanded
    ? `top ${transitionDuration}ms ease-out, width ${transitionDuration}ms ease-out ${transitionDuration}ms`
    : `top ${transitionDuration}ms ease-out ${transitionDuration}ms, width ${transitionDuration}ms ease-out`,
});

export const Container = styled(Box)(ContainerStyle);
